<template>
  <nuxt-layout name="common" :navigation="!profile.needToDefineMainContent">
    <Nomad v-if="!error" />
  </nuxt-layout>
</template>

<script lang="ts" setup>
const { $sentryCaptureException } = useNuxtApp();

const loadingIndicator = useLoadingIndicator();

const profile = useProfileStore();

definePageMeta({
  locked: true,
});

const error = ref();

const lbType = profile.needToDefineMainContent
  ? LibraryTypes.FreeLibraryRootBox
  : LibraryTypes.RootBox;

const libraryPage = useLibraryPageOrForm('page', lbType);

loadingIndicator.start();
try {
  await libraryPage.libraryManager.load(
    libraryPage.libraryStrategy.slugs.value,
    2
  );
  provide(INJECT_LIBRARY_PAGE_OR_FORM, libraryPage);
} catch (e) {
  error.value = e;
  $sentryCaptureException(e);
  navigateTo('/nomad', { replace: true });
}

loadingIndicator.finish();
</script>

<style lang="scss" scoped>
header {
  display: flex;
  flex-direction: column;
  gap: var(--gap_m);
  color: var(--color_primary);
  font-size: var(--text_size_xxl);
  h1 {
    margin: 0;
  }
  :deep(p) {
    @include font('xl', 800);

    color: var(--color_primary);
    font-style: italic;
  }
  :deep(ul) {
    display: flex;
    flex-direction: column;
    gap: var(--gap_n);
    color: var(--color_neutral_800);
    @include font('m', 500);
  }
}
</style>
